export default "__VITE_PUBLIC_ASSET__94cff7c3__"